import axios from "axios";
import { API_URL } from "../utils/ApiUrl";
import { useEventSessionContext } from "../contexts/EventSessionContext";
import Environment from "../utils/Environment";

const useRecordEvent = () => {
  const Presale = Environment.presale;
  const { eventSessionId, setEventSessionId } = useEventSessionContext();

  /**
   * INIT SESSION (called once)
   */
  const initSession = async (utmSource) => {
    const existingSessionId = localStorage.getItem("eventSessionId");
    if (existingSessionId) {
      setEventSessionId(existingSessionId);
      return existingSessionId;
    }

    const payload = {
      privateSale: Presale.apiTag,
      source: utmSource || "direct",
    };

    const response = await axios.post(`${API_URL}logs/create-funnel`, payload);

    const sessionId = response?.data?.data?._id;

    setEventSessionId(sessionId);
    localStorage.setItem("eventSessionId", sessionId);

    return sessionId;
  };

  /**
   * RECORD EVENT (PATCH)
   */
  const recordEvent = async (metaData) => {
    try {
      const sessionId =
        eventSessionId || localStorage.getItem("eventSessionId");

      if (!sessionId) {
        console.warn("No sessionId found, event skipped");
        return;
      }

      await axios.patch(`${API_URL}logs/update-funnel`, {
        id: sessionId,
        ...metaData,
      });
    } catch (error) {
      console.error("Error recording event:", error);
    }
  };

  return { initSession, recordEvent };
};

export default useRecordEvent;
